import { httpService } from '../..';
import { IEntityWithMessages } from '../../services/HttpService';
import { IApiExecuteRespone } from '../apiInterfaces';
import { ApiUrls } from '../ApiUrls';
import { executeApiRequest } from '../asyncUtils';
import {
  IDealerCashDiscountQueryResponse,
  IProgram,
  IProgramCashDiscount,
  IProgramGroup,
  IProgramLevel,
  IProgramPreSeasonSetup
} from './programsInterfaces';

export async function deleteCashDiscount(programCashDiscountId: number) {
  return executeApiRequest(() => httpService.delete(ApiUrls.programCashDiscount({ programCashDiscountId })), false);
}

export async function fetchCashDiscounts(fiscalYear: string) {
  return executeApiRequest<IProgramCashDiscount[]>(() => httpService.get(ApiUrls.programCashDiscount({ fiscalYear })));
}

export async function fetchPrograms(fiscalYear: string) {
  return executeApiRequest<IProgram[]>(() => httpService.get(ApiUrls.getPrograms(fiscalYear)));
}

export async function queryCashDiscounts(values: { accountNum: string; fiscalYear: string }) {
  return executeApiRequest<IDealerCashDiscountQueryResponse>(() => httpService.get(ApiUrls.cashDiscountQuery(values)));
}

export async function updateCashDiscount(discount: IProgramCashDiscount) {
  return executeApiRequest<IProgramCashDiscount>(() => httpService.post(ApiUrls.programCashDiscount(), discount));
}

export async function updateProgramPreSeasonSetup(
  setup: IProgramPreSeasonSetup
): Promise<IApiExecuteRespone<IProgramPreSeasonSetup>> {
  return executeApiRequest(() => httpService.post(ApiUrls.programPreSeasonSetup(), setup));
}

export async function deleteProgramGroup(
  programGroupId: number
): Promise<IApiExecuteRespone<IEntityWithMessages<number>>> {
  const response: IApiExecuteRespone<IEntityWithMessages<number>> = {
    requestFailed: false
  };

  try {
    const apiResponse = await httpService.delete(ApiUrls.programGroup(programGroupId));
    response.value = await apiResponse.json();
  } catch (e) {
    response.exception = e;
    response.requestFailed = true;
  }

  return response;
}

export async function deleteProgramLevel(
  programLevelId: number
): Promise<IApiExecuteRespone<IEntityWithMessages<number>>> {
  const response: IApiExecuteRespone<IEntityWithMessages<number>> = {
    requestFailed: false
  };

  try {
    const apiResponse = await httpService.delete(ApiUrls.programLevel(programLevelId));
    response.value = await apiResponse.json();
  } catch (e) {
    response.exception = e;
    response.requestFailed = true;
  }

  return response;
}

export async function fetchProgramPreSeasonSetup(
  fiscalYear: string
): Promise<IApiExecuteRespone<IProgramPreSeasonSetup[]>> {
  return executeApiRequest<IProgramPreSeasonSetup[]>(() => httpService.get(ApiUrls.programPreSeasonSetup(fiscalYear)));
}

export async function updateProgramGroup(programGroup: IProgramGroup): Promise<IApiExecuteRespone<IProgramGroup>> {
  const response: IApiExecuteRespone<IProgramGroup> = { requestFailed: false };

  try {
    const apiResponse = await httpService.post(ApiUrls.programGroup(), programGroup);
    response.value = await apiResponse.json();
  } catch (e) {
    response.exception = e;
    response.requestFailed = true;
  }

  return response;
}

export async function updateProgramlevel(programLevel: IProgramLevel): Promise<IApiExecuteRespone<IProgramLevel>> {
  const response: IApiExecuteRespone<IProgramLevel> = { requestFailed: false };

  try {
    const apiResponse = await httpService.post(ApiUrls.programLevel(), programLevel);
    response.value = await apiResponse.json();
  } catch (e) {
    response.exception = e;
    response.requestFailed = true;
  }

  return response;
}
